import { z } from 'zod';
/** A branch as shown in lists and details (from Unified Access). */
export const branchRefSchema = z.object({
    id: z.string(),
    code: z.string(),
    nameAr: z.string(),
    nameEn: z.string(),
});
/** The real employee behind an action. */
export const employeeRefSchema = z.object({
    id: z.string(),
    nameAr: z.string(),
    nameEn: z.string(),
});
/** Text kept in both product languages, e.g. a bilingual setting. */
export const bilingualTextSchema = z.object({
    ar: z.string(),
    en: z.string(),
});
export const bilingualTextInputSchema = z.object({
    ar: z.string().trim().max(2000),
    en: z.string().trim().max(2000),
});
/** ACTIVE / INACTIVE for records that can be disabled (تغيير الحالة). */
export const recordStatusSchema = z.enum(['ACTIVE', 'INACTIVE']);
export const changeStatusSchema = z.object({ status: recordStatusSchema });
/** A calendar date `YYYY-MM-DD` in the organisation's time zone (Asia/Amman). */
export const dateOnlySchema = z.iso.date();
/**
 * `GET /branches`: every branch (the user drawer assigns any of them), or with
 * `scope=mine` only the signed-in user's branches, which the debts pages offer
 * in their forms and filters (debts.md section 4).
 */
export const branchListQuerySchema = z.object({
    scope: z.enum(['all', 'mine']).default('all'),
});
//# sourceMappingURL=refs.js.map